import React from 'react'
import styled from 'styled-components'

export const List = styled.dl`
  border: 1px solid ${(props) => props.theme.colors.grey_op25};
  display: flex;
  flex-wrap: wrap;

  @media (min-width: 600px) {
    display: static;
  }
`

export const Row = styled.div`
  padding: 10px;
  line-height: 1.5;
  flex: 1 0 50%;

  @media (max-width: 599px) {
    &:nth-child(n + 3) {
      border-top: 1px solid ${(props) => props.theme.colors.grey_op25};
    }

    &:nth-child(even) {
      border-left: 1px solid ${(props) => props.theme.colors.grey_op25};
    }
  }

  dt,
  dd {
    margin: 0;
  }

  @media (min-width: 600px) {
    padding: 0;
    display: flex;
    flex: 1 0 100%;
    width: 100%;
    border: 0;

    & + & {
      border-top: 1px solid ${(props) => props.theme.colors.grey_op25};
    }

    &:nth-child(odd) {
      background: ${(props) => props.theme.colors.grey_op05};
    }

    dt,
    dd {
      flex: 1 0 50%;
      padding: 10px 10px;
    }

    dd {
      border-left: 1px solid ${(props) => props.theme.colors.grey_op25};
    }
  }
`

const OfferDetailsTableWidget = ({ container: Container, items, pageType }) => {
  return (
    <Container {...(pageType !== 'article' && { mt: 35 })}>
      <List>
        {items.map((item, index) => (
          <Row key={index}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </Row>
        ))}
      </List>
    </Container>
  )
}

export default OfferDetailsTableWidget
